import { render, staticRenderFns } from "./onlinePayment.vue?vue&type=template&id=0bdd839d&scoped=true"
import script from "./onlinePayment.vue?vue&type=script&lang=js"
export * from "./onlinePayment.vue?vue&type=script&lang=js"
import style0 from "./onlinePayment.vue?vue&type=style&index=0&id=0bdd839d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdd839d",
  null
  
)

export default component.exports